var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 2.41667H22.9583V0H20.5417V2.41667H13.2917V0H10.875V2.41667H8.45833C6.45975 2.41667 4.83333 4.04308 4.83333 6.04167V24.1667H29V6.04167C29 4.04308 27.3736 2.41667 25.375 2.41667ZM8.45833 4.83333H25.375C26.042 4.83333 26.5833 5.37587 26.5833 6.04167V8.45833H7.25V6.04167C7.25 5.37587 7.79133 4.83333 8.45833 4.83333ZM7.25 21.75V10.875H26.5833V21.75H7.25ZM2.41667 26.5833H24.1667V29H0V9.66667H2.41667V26.5833Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendedLogo);
export default __webpack_public_path__ + "static/media/sended-logo.67fbe1a0cc0c41ecbe596471aea9488c.svg";
export { ForwardRef as ReactComponent };